import { withStyles } from "@material-ui/core/styles";
import appConstants from "../../../../../../appConstants";
const styles = (theme) => ({
  stopIcon: {
    display: "inline-flex",
    width: 20,
    height: 20,
    border: `1px solid ${theme.TextColor}`,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 4,
    marginLeft: 4,
  },
  pickupStop: {
    borderRadius: "2px",
  },
  deliveryStop: {
    borderRadius: "10px",
  },
  nextStopMessage: {
    marginLeft: 2,
    marginRight: 2,
  },
  stopName: {
    fontWeight: 600,
  },
});

const renderStopIcon = (stopData, classes) => {
  return (
    <span
      className={`${
        stopData.stopType === appConstants.STOP_TYPE.Pickup
          ? classes.pickupStop
          : classes.deliveryStop
      } ${classes.stopIcon}`}
    >
      {stopData.stopSequence}
    </span>
  );
};

const MakeNextStopFeedbackMessage = ({
  nextStopMarkedData,
  updatedStopData,
  classes,
}) => {
  return (
    <div>
      <span className={classes.stopName}>{nextStopMarkedData?.name}</span>
      <span> moved from </span>
      {renderStopIcon(nextStopMarkedData, classes)}
      <span className={classes.nextStopMessage}>to</span>
      {renderStopIcon(updatedStopData, classes)}
    </div>
  );
};

export default withStyles(styles)(MakeNextStopFeedbackMessage);
